export const VISIT_ROUTES = {
  home: "/",
  // personal: "/personal/:activeSubStep?",
  // project: "/project/:activeSubStep?",
  // contact: "/contact",
  // appointment: "/appointment/:activeSubStep?",
  wizard: "/wizard/:wizardId?/:leadStepName?/:activeSubStep?",
  contact: "/contact",
  thanks: "/thanks",
  review: "/review",
  success: "/success",
};

// export const VISIT_ROUTES = {
//   home: "/:wizardId?",
//   product: "/:wizardId?/product/:activeSubStep?",
//   personal: "/:wizardId?/personal/:activeSubStep?",
//   contact: "/:wizardId?/contact",
//   appointment: "/:wizardId?/appointment/:activeSubStep?",
//   review: "/:wizardId?/review",
//   success: "/:wizardId?/success",
// };

export const VISIT_STEPS = {
  wizard: "/wizard",
  personal: "/personal",
  project: "/project",
  contact: "/contact",
  appointment: "/appointment",
  review: "/review",
  success: "/success",
}

export const IS_DEV_MODE = window.location.href.indexOf('dev=1') !== -1 || document.kvConfig.devMode;
export const SKIP_CALENDAR = window.location.href.indexOf('skip=1') !== -1;
